<template>
  <v-footer dark height="auto">
    <v-card class="flex" flat tile>
      <v-card-title class="grey darken-3">
        <v-layout row wrap justify-space-around align-center>
          <v-flex xs12 lg12>
            <img src="@/assets/logo.png" alt="caos suits logo" />
          </v-flex>
          <v-flex>
            <v-layout class="my-3" :column="$vuetify.breakpoint.smAndUp">
              <v-flex>
                <v-btn to="/suits" flat>Custom Suits</v-btn>
              </v-flex>
              <v-flex>
                <v-btn to="/about" flat>About</v-btn>
              </v-flex>
              <v-flex>
                <v-btn to="/contact" flat>Contact</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex>
            <v-layout column>
              <v-flex>
                <v-btn
                  href="https://www.facebook.com/heath.thomas.501?fref=nf&__tn__=%2Cdm-R-R&eid=ARC5butTMnpAPjBwHQCn71Z3qA0qFZ_pPKbtQSVDDHWvIGyovAUYYwhlSES22euj1cTs1pLvlTECrE9a"
                  rel="noopener noreferrer"
                  target="_blank"
                  flat
                >
                  Facebook
                </v-btn>
              </v-flex>
              <v-flex>
                <v-btn
                  href="https://www.instagram.com/caossuits/"
                  rel="noopener noreferrer"
                  target="_blank"
                  flat
                >
                  Instagram
                </v-btn>
              </v-flex>
              <v-flex>
                <v-btn @click="mail" flat>info@caos.store</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>

      <!-- <v-card-actions class="px-4 grey darken-2 justify-center">
      &copy;{{(new Date()).getFullYear()}} — <strong>Mladen Skrbic</strong>
      <v-spacer></v-spacer>
      terms&privacy
    </v-card-actions> -->
    </v-card>
  </v-footer>
</template>

<script>
  export default {
    methods: {
      mail() {
        location.href='mailto:"info@caos.store"'
      }
    }
  }
</script>

<style scoped>
img {
  max-width: 150px;
}
i {
  font-size: 2rem;
}
</style>
